import placeholder from "../../assets/img/product-placeholder.png";

export const getEventPhotoUrl = ( event, api )=> {
  return event?.image
    ? api.appFiles.getUrl(
        parseInt(event.image.substring(event.image.lastIndexOf('/') + 1))
      )
    : placeholder;
};
